import { render, staticRenderFns } from "./Multichoice.vue?vue&type=template&id=56a79288&"
import script from "./Multichoice.vue?vue&type=script&lang=ts&"
export * from "./Multichoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports